import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRadium, SearchParams, gtmEvent } from "higher-order-components"
import { ConfiguredVehicle, FixedBar } from "containers"
import { GlobalNavItemGrid } from "components"
import { Button , H2, P, Section } from 'AtomicComponents'
import { HAS_TOUCH, WINDOW } from "AtomicUtils/environment"
import componentParser from "AtomicUtils/componentParser"
// Redux
import { compareVehicleSelectorActionTypes } from "store/gtm-events"

const closeIcon = () => (
  <svg data-test="compare-remove" viewBox="0 0 17 17" style={{ fill: "#910A2D" }}>
    <path d="M8.5,0A8.5,8.5,0,1,0,17,8.5,8.5,8.5,0,0,0,8.5,0Zm3.24,10.62a0.75,0.75,0,0,1,0,1.14,1,1,0,0,1-1.26,0l-2-2-2,2a1,1,0,0,1-1.26,0,0.75,0.75,0,0,1,0-1.14L7.32,8.5,5.26,6.38a0.75,0.75,0,0,1,0-1.14,1,1,0,0,1,1.26,0l2,2,2-2a1,1,0,0,1,1.26,0,0.75,0.75,0,0,1,0,1.14L9.68,8.5Z" />
  </svg>
)

const carOutline = () => (
  <svg data-test="car-outline" viewBox="0 0 111 54" style={{ height: "3em" }}>
    <path d="M110.88,24.73a6.66,6.66,0,0,0-.16-1.07c-0.22-1.8-1-3.56-1.2-5.34-0.26-.61.63-4.7-1.15-4.31a44.53,44.53,0,0,1-3.88-2.66c-1.16-1-2.2-2.19-3.27-3.31-1.36-.9-2.31-2.18-3.51-3a27.75,27.75,0,0,0-4.58-2.77A44.4,44.4,0,0,0,86.52.56C85.32,0.39,83.9.4,82.58,0.29,79,0,75.64,0,72,0S64.74,0.2,61.12.4c-2.42.13-4.89,0.73-7.28,0.73a16.47,16.47,0,0,0-2.18.26,17.86,17.86,0,0,0-3.55.51C47.88,2,47,2.22,46.26,2.49h0A17.57,17.57,0,0,0,44,3.37l-0.1.05a17.25,17.25,0,0,0-1.72.9L41,5c-0.34.17-.72,0.37-1.09,0.57h0a7.44,7.44,0,0,0-.82.52L36.28,7.8l0,0a22.11,22.11,0,0,0-2.11,1.63c-0.4.15-2.8,1.89-2.84,1.91h0c-0.3.17-.59,0.34-0.89,0.53a2.85,2.85,0,0,0-.92.48,5.58,5.58,0,0,0-.3,1,1.45,1.45,0,0,1-.61.4,9,9,0,0,1-3.53.82,50,50,0,0,0-10,2.29,24,24,0,0,0-3.37,1.37c-1.15.6-2.12,1.45-3.24,2-0.4.2-4.4,2.14-5.45,2.83H3l-0.42.19-0.23.18h0A4.06,4.06,0,0,0,2,26.76c0.22,0.22-.93,1.48-1,1.62-0.48.79-.93,6.27-1,7.51a12.56,12.56,0,0,0,.24,2.67c0.17,1.23-.29,2.53,0,3.74a6.64,6.64,0,0,0,.63,1c0,0.8,2.08,1.94,2.67,2.26,0.92,0.5.93,0.16,1.84,0.22a4.6,4.6,0,0,1,1.34.7c0.61,0.23,1.32,0,1.91.18a1.26,1.26,0,0,1,.44.28,8.39,8.39,0,0,0,12.72.33,2.84,2.84,0,0,1,1.36-.17c1.42,0,26.27,1.14,30,1.48a7.19,7.19,0,0,1,1.67.45,2.28,2.28,0,0,1,.81,0,4.49,4.49,0,0,1,.75,1.09,6.25,6.25,0,0,0,1.74,1.68A7.71,7.71,0,0,0,59.62,53a8,8,0,0,0,8,0l0.1,0a2.17,2.17,0,0,0,.31-0.2,9.15,9.15,0,0,0,4.24-7,1.74,1.74,0,0,1,.66-0.94c0.85-.54,22.59-5,23.44-5.09,0,0,1.22,0,1.25,0a1.59,1.59,0,0,0,0,.83,4.52,4.52,0,0,0,.5.29c0.12,0.12.23,0.33,0.41,0.52,0.87,0.89,1.3,1.56,2.63,1.77,1.69,0.27,4.7.54,6-.79,1.59-1.64,1.85-4.18,2.22-6.42,0.19-1.15.81-2.11,1-3.33a13.51,13.51,0,0,0,.34-2.57C110.74,28.22,111.22,26.46,110.88,24.73Z" />
  </svg>
)

/** Renders a Compare vehicle selector */
class CompareVehicleSelectorContainer extends Component {
  constructor(props) {
    super(props)
    const preSelectLeft = props.search.query.selectionLeft || ""
    const preSelectRight = props.search.query.selectionRight || ""
    const findNameplate = preSelectSlug => {
      return componentParser(props.components).find(({ props: { slug } }) => slug && slug.toLowerCase() === preSelectSlug.toLowerCase())
    }
    const findNameplateProps = (preSelectSlug) => {
      const comp = findNameplate(preSelectSlug)
      return comp ? comp.props : false
    }
    this.state = {
      selectionLeft: findNameplateProps(preSelectLeft),
      selectionRight: findNameplateProps(preSelectRight),
      selection: "selectionLeft"
    }
  }
  static propTypes = {
    components: PropTypes.array,
    heading: PropTypes.string,
    ctaText: PropTypes.string,
    ctaHref: PropTypes.string,
    search: PropTypes.shape({
      query: PropTypes.shape({
        selectionLeft: PropTypes.string,
        selectionRight: PropTypes.string
      })
    }),
    text: PropTypes.string
  }
  hover = (position, state) => {
    this.setState({ [`${position}hover`]: state })
  }
  selectedVehicle = (position) => {
    const pos = this.state[position]
    const hover = this.state[`${position}hover`]
    return (
      <div
        style={[styles.icon, styles[position]]}
        key={position}
        onClick={() => {
          this.setSelection(position)
        }}
        onMouseOver={() => this.hover(position, true)}
        onMouseOut={() => this.hover(position, false)}>
        {/* Always show 'x' icon on touch device, on desktop only show when hover */
        pos && HAS_TOUCH ? (
          <div style={styles.closeIcon}>{closeIcon()}</div>
        ) : (
          pos && hover && <div style={styles.closeIcon}>{closeIcon()}</div>
        )}
        {pos ? <ConfiguredVehicle src={pos.selectionImageSrc} /> : carOutline()}
      </div>
    )
  }
  handleSelection = (index) => {
    const item = componentParser(this.props.components)[index].props
    if (!this.state.selectionLeft) {
      this.setSelectionValue("selectionLeft", item)
    } else if (!this.state.selectionRight) {
      this.setSelectionValue("selectionRight", item)
    }
    this.refs.compare.reset()
  }

  setSelectionValue = (selection, item) => {
    const { search } = this.props
    search.pushParam({ [selection]: item.slug })
    this.setState({ selection: selection }, () => {
      this.setState({ [this.state.selection]: item })
    })
  }
  setSelection = (position) => {
    const { search } = this.props
    search.pushParam({ [position]: false })
    this.setState({ [position]: false, selection: position })
  }
  childProps = index => ({
    onClick: () => this.handleSelection(index)
  })
  /**
   * @param {String} Heading - Heading text.
   * @returns {ReactElement} react component
   */
  render() {
    const message = !this.state.selectionLeft
      ? "Select first model"
      : !this.state.selectionRight ? "Select second model" : false
    return (
      <div>
        <Section textAlign="center" padding backgroundColor="#F5F5F5">
          {componentParser(this.props.components.slice(0, 1))}
          <div
            style={[{ width: "100%" },
              this.state.selectionLeft &&
                this.state.selectionRight && {
                  pointerEvents: "none",
                  opacity: 0.33,
                  transition: ".25s"
                }
            ]}>
            <GlobalNavItemGrid ref="compare">
              {componentParser(this.props.components).slice(1).map((comp, index) =>
                React.cloneElement(comp, this.childProps(index + 1)))}
            </GlobalNavItemGrid>
          </div>
        </Section>
        <FixedBar>
          <div
            style={{
              textAlign: "center",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              height: message ? "4em" : "5em",
              transition: ".3s"
            }}>
            {this.selectedVehicle("selectionLeft")}
            <div data-test="message" style={styles.message}>
              {message || (
                <Button
                  display="inline"
                  disabled={!(this.state.selectionLeft && this.state.selectionRight)}
                  label={
                    WINDOW.innerWidth > 481
                      ? this.props.ctaText
                      : this.props.ctaText.substring(0, 7)
                  }
                  href={`${this.props.ctaHref}?cars=${this.state.selectionLeft.slug},${this.state
                    .selectionRight.slug}`}
                  onClick={() =>
                    this.props.gtmEvent({
                      gtmID:
                        compareVehicleSelectorActionTypes.COMPARE_VEHICLE_SELECTOR_CLICK_COMPARE,
                      gtmPayload: {
                        model1: this.state.selectionLeft.slug,
                        model2: this.state.selectionRight.slug
                      }
                    })} />
              )}
            </div>
            {this.selectedVehicle("selectionRight")}
          </div>
        </FixedBar>
      </div>
    )
  }
}

export default withRadium(
  SearchParams({
    expose: "search",
    exposeParams: ["selectionLeft", "selectionRight"]
  }),
  gtmEvent()
)(CompareVehicleSelectorContainer)

const styles = {
  closeIcon: {
    fill: "#910A2D",
    height: "1em",
    width: "1em",
    right: 0,
    top: 0,
    position: "absolute",
    pointerEvents: "none"
  },
  message: {
    letterSpacing: "0.2em",
    fontWeight: "600",
    color: "#101010",
    textTransform: "uppercase"
  },
  icon: {
    flex: "0 0 7em",
    display: "flex",
    alignItems: "center",
    position: "relative",
    cursor: "pointer",
    fill: "#dbdbdb",
    verticalAlign: "middle",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: "2em",
    marginRight: "2em",
    "@media (max-width: 30em)": {
      marginLeft: ".2em",
      marginRight: ".2em",
      flex: "1 1 7em"
    }
  },
  selectionLeft: {
    marginLeft: "auto"
  },
  selectionRight: {
    marginRight: "auto"
  }
}



// WEBPACK FOOTER //
// ./src/containers/compare-vehicle-selector/index.jsx